import React, { useEffect } from "react";
import { Helmet } from "react-helmet";
import {
  loadCaptchaEnginge,
  LoadCanvasTemplate,
  validateCaptcha,
} from "react-simple-captcha";

function Complaint() {
  useEffect(() => {
    loadCaptchaEnginge(6);
  }, []);

  const handleSubmit = (e) => {
    e.preventDefault();
    const user_captcha = e.target.captcha.value;

    if (validateCaptcha(user_captcha) === true) {
      e.target.action = "https://formsubmit.co/vbumca@gmail.com";
      e.target.method = "POST";
      e.target.submit();
    } else {
      alert("Captcha does not match. Please try again.");
      loadCaptchaEnginge(6);
      e.target.captcha.value = "";
    }
  };

  return (
    <>
      <Helmet>
        <title>Complaint Form - VBU MCA</title>
      </Helmet>
      <div className="PageContainer">
        <div id="Heading">
          <h1>Complaint Form</h1>
        </div>
        <div className="FormWrapper" data-aos="fade-up">
          <div className="FormContent">
            <form className="StandardForm" onSubmit={handleSubmit}>
              <input type="hidden" name="_subject" value="New Complaint from VBU MCA Website" />
              <div className="FormRow">
                <div className="InputField">
                  <label>Name</label>
                  <input type="text" name="name" placeholder="Enter Your Name" required />
                </div>
                <div className="InputField">
                  <label>University Roll No</label>
                  <input type="text" name="roll_no" placeholder="Enter Your Roll No" required />
                </div>
              </div>
              <div className="FormRow">
                <div className="InputField">
                  <label>Course</label>
                  <select name="course" required>
                    <option value="">Select Course</option>
                    <option value="MCA">MCA</option>
                    <option value="BCA">BCA</option>
                  </select>
                </div>
                <div className="InputField">
                  <label>Semester</label>
                  <select name="semester" required>
                    <option value="">Select Semester</option>
                    <option value="I">Semester I</option>
                    <option value="II">Semester II</option>
                    <option value="III">Semester III</option>
                    <option value="IV">Semester IV</option>
                    <option value="V">Semester V</option>
                    <option value="VI">Semester VI</option>
                  </select>
                </div>
              </div>
              <div className="InputField">
                <label>Complaint Title</label>
                <input type="text" name="title" placeholder="Enter title" required />
              </div>
              <div className="InputField">
                <label>Description</label>
                <textarea name="description" placeholder="Describe Your Complain Title" rows="6" required></textarea>
              </div>
              <div className="InputField">
                <label>Enter Captcha</label>
                <div className="CaptchaWrapper" style={{ display: 'flex', gap: '15px', alignItems: 'center' }}>
                  <LoadCanvasTemplate />
                  <input
                    type="text"
                    name="captcha"
                    placeholder="Enter Captcha Here"
                    className="capthca_box"
                    required
                    style={{ width: '200px' }}
                  />
                </div>
              </div>
              <button type="submit" className="SubmitBtn">POST</button>
            </form>
          </div>
          <div className="FormImage">
            <img src="https://console.vbumca.in/Images/background-1.svg" />
          </div>
        </div>
      </div>
    </>
  );
}

export default Complaint;
